<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import {useOutStateModelStore} from "@/stores/OutStateModel";
import {onMounted, ref} from "vue";
import BlankModel from "@/views/OutStateModel/Components/BlankModel.vue";
import axios from "axios";

export default {
    components: {BlankModel},
    setup() {
        const {$i18n, $router} = useTools();

        const {
            loading,
            total,
        } = useSharedData();

        const securityStore = useSecurityStore();
        const outStateModelStore = useOutStateModelStore();


        const search = ref(null);

        const headers = [
            {
                text: "",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.type"),
                align: "start",
                sortable: true,
                value: "type",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: true,
                value: "name",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'out_state_models.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'out_state_models.delete', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/outStateModels').then((response) => {
                outStateModelStore.setOutStateModels(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "out_state_models.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            outStateModelStore,
            loading,
            total,
            headers,
            actions,
            search,
            view,
            findAll,
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.out_state_model')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    @press="$router.push({ name: 'out_state_models.add' })"
                />
                <BlankModel/>
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="outStateModelStore.outStateModels"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >


                    <template v-slot:[`item.type`]="{item}">
                        <w-chip :text="$t(`out_state_model.${item.type}`)"/>
                    </template>
                    <template v-slot:[`item.name`]="{item}">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>